// Need to stay this way because we have this dependency on EnvNameType in auth lib.

export enum ENVS {
	BETA = "beta",
	DEV = "dev",
	LOCAL = "local",
	PROD = "prod",
	STAGING = "staging",
	STAGINGUK = "ukstaging",
	PRODUK = "ukprod",
}
